/**
 * @file   src\components\CWOProtectedRoute.tsx
 * @brief  This component used for manage and protect unauthorized/permission based url access for carwash admin.
 * @date   October, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */

import {React,  Navigate, useLocation,  useParams, matchPath } from '../utils/thirdpartyComponents';
import { getFromLocalStorage } from '../utils/helper';
import { pageURLs } from '../utils/pageUrls';
import Cookies from 'js-cookie';

interface Props {
  children: JSX.Element;
  // any props that come into the component
}
const CWOProtectedRoute = ({ children }: Props) => {
  const params = useParams();
  /* Create location object to access location info. */
  const storageData = getFromLocalStorage('CARWASH_OWNER_DATA');
  const userInfo = storageData && storageData !== null ? storageData : null;
  const isAuthenticated = userInfo !== null && Cookies.get('accessToken')!== ''
  // userInfo?.accessToken !== '';

  /* Check whether the user is authenticated or not and redirected to login page. */
  if (!isAuthenticated) {
    return <Navigate to={`/${pageURLs.root}`}  replace />;
  }
  else  if(userInfo?.userTypeId === 4 && userInfo?.permissionType === 2 && IsLocationManagerAllowed()==null){
    window.location.href = `${process.env.REACT_APP_SITE_URL + pageURLs.carwash_locations}`
  }
  else {
    localStorage.removeItem('CARWASH_ADMIN_DATA');
  }

  return children;
};

const IsLocationManagerAllowed = ()=> {
  const locationmanagerallowed_urls = [
    pageURLs.my_profile,
    pageURLs.manage_users,
    pageURLs.carwash_locations,
    pageURLs.add_relaynumber,
    pageURLs.equipment_listing,
    pageURLs.add_equipment,
    pageURLs.edit_equipment,
    pageURLs.edit_location,
    pageURLs.manage_subscriptions,
    pageURLs.add_subscription,
    pageURLs.edit_subscription,
    pageURLs.carwash_sign_generation
  ]
  const pathname = useLocation().pathname;
  let pattern = null;

  locationmanagerallowed_urls.forEach((val: string) => {
    const pattern1 = matchPath({ path: val, end: false }, pathname);
    if (pattern1 != null) {
      pattern = pattern1;
      return pattern;
    }
  });

  return pattern;
  
}

export default CWOProtectedRoute;
